import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
const _hoisted_2 = {
  key: 1,
  class: "vw-100 vh-100 d-flex align-items-center justify-content-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_translations = _resolveComponent("translations");
  const _component_alerts = _resolveComponent("alerts");
  const _component_main_modal = _resolveComponent("main-modal");
  const _component_router_view = _resolveComponent("router-view");
  const _component_BSpinner = _resolveComponent("BSpinner");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_translations), _createVNode(_component_alerts), _createVNode(_component_main_modal), _ctx.translationsLoaded ? (_openBlock(), _createBlock(_component_router_view, {
    key: 0
  })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_BSpinner)]))]);
}